/* eslint-disable react/jsx-key */
import React, { Component } from "react"
import { connect } from "react-redux"
import {
  getProduct,
  postImage,
  deleteImages,
  putProduct,
} from "../ducks/product"
import BarCode from "../components/BarCode"
import ReactToPrint from "react-to-print"
import { Button, Input, Card, Table, Icon, Confirm } from "semantic-ui-react"
import { getImagesApi } from "../config/apiUrls"
import { Carousel } from "react-responsive-carousel"
import { withTranslation } from "react-i18next"

@connect(
  (state) => ({
    product: state.product,
  }),
  (dispatch) => ({
    getProduct: (barcode) => dispatch(getProduct(barcode)),
    postImage: (catalogId, images) => dispatch(postImage(catalogId, images)),
    deleteImages: (catalogId, images) =>
      dispatch(deleteImages(catalogId, images)),
    putProduct: (barcode, name, salePrice, purchasePrice, measureId) =>
      dispatch(putProduct(barcode, name, salePrice, purchasePrice, measureId)),
  }),
)
@withTranslation()
class ProductPage extends Component {
  componentDidMount() {
    this.props.getProduct(this.props.stockId)
    this.setState({ attributes: this.props.product.product.attributes })
  }

  componentDidUpdate() {
    if (this.props.product.product.barcode !== this.state.barcode) {
      const images = (this.props.product.product.images || []).map((el) =>
        this.getImage(el),
      )
      this.setState({
        name: this.props.product.product.name,
        barcode: this.props.product.product.barcode,
        attributes: this.props.product.product.attributes,
        catalogId: this.props.product.product.catalogId,
        purchasePrice: this.props.product.product.purchasePrice,
        salePrice: this.props.product.product.salePrice,
        images: (this.props.product.product.images || []).map((el) =>
          this.getImage(el),
        ),
        shortName: this.props.product.product.shortName,
        remainder: this.props.product.product.remainder,
        measureId: this.props.product.product.measureId,
      })
    }
  }
  state = {
    settings: this.props.settings,
    attributes: this.props.product.product.attributes,
    images: (this.props.product.product.images || []).map((el) =>
      this.getImage(el),
    ),
    name: this.props.product.product.name,
    barcode: this.props.product.product.barcode,
    catalogId: this.props.product.product.catalogId,
    selectedFiles: [],
    deletedImages: [],
    inputName: "",
    purchasePrice: this.props.product.product.purchasePrice,
    salePrice: this.props.product.product.salePrice,
    inputPurchasePrice: "",
    inputSalePrice: "",
    measureId: this.props.product.product.measureId,
    remainder: this.props.product.product.remainder,
    shortName: this.props.product.product.shortName,
    open: false,
  }

  getImage(image) {
    return getImagesApi + image
  }

  save = () => {
    this.state.selectedFiles.map((el) =>
      this.props.postImage(this.state.catalogId, el),
    )
    this.props.deleteImages(this.state.catalogId, {
      images: this.state.deletedImages,
    })
    this.props.putProduct(
      this.state.barcode,
      this.state.name,
      this.state.salePrice,
      this.state.purchasePrice,
      this.state.measureId,
    )
    this.props.getProduct(this.props.stockId)
  }

  fileChangedHandler = (event) => {
    const images = [...this.state.images]
    const selectedFiles = [...this.state.selectedFiles]
    for (let i = 0; i < event.target.files.length; i++) {
      selectedFiles.push(event.target.files[i])
      let reader = new FileReader()
      reader.onloadend = () => {
        images.push(reader.result)
        this.setState({
          selectedFiles: selectedFiles,
          images: images,
        })
      }
      reader.readAsDataURL(event.target.files[i])
    }
  }

  deleteImage = (el, i) => {
    const deletedImages = [...this.state.deletedImages]
    const selectedFiles = this.state.selectedFiles.filter((q, ind) => i !== ind)
    const images = this.state.images.filter((q, ind) => i !== ind)
    if (
      el.slice(el.length - 4, el.length) === ".jpg" &&
      ~el.indexOf(getImagesApi)
    ) {
      deletedImages.push(el.slice(el.lastIndexOf("/") + 1, el.length))
    }
    this.setState({
      deletedImages: deletedImages,
      images: images,
      selectedFiles: selectedFiles,
    })
    return true
  }

  render() {
    const { t } = this.props
    let settings = this.state.settings
    let id = "product-image-upload-id"
    return (
      <div className="product-container">
        {
          <div className="product-container-button-div">
            {settings ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <h2
                  style={{
                    margin: 0,
                  }}
                >
                  {this.state.name}
                </h2>
                <Button
                  className="product-container-button"
                  onClick={() => {
                    this.setState({ settings: false })
                    this.save()
                  }}
                  color="green"
                >
                  {t("saveChanges")}
                </Button>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h2 style={{ margin: 0 }}>{this.state.name}</h2>
                <Button
                  className="product-container-button"
                  onClick={() => {
                    this.setState({ settings: true })
                  }}
                >
                  {t("edit")}
                </Button>
              </div>
            )}
          </div>
        }
        <Card.Group fluid className="product-info-container">
          <Card className="product-carousel-card">
            {settings ? (
              <div className="product-upload-images">
                <Icon name="upload" size="large" />
                <input
                  id={id}
                  type="file"
                  onChange={this.fileChangedHandler}
                  multiple
                  name="file"
                />
              </div>
            ) : (
              <></>
            )}
            {this.state.images.length ? (
              <Carousel
                showArrows={true}
                infiniteLoop={true}
                showThumbs={false}
              >
                {this.state.images.map((el, i) => {
                  return (
                    <div className="product-carousel">
                      {settings ? (
                        <i
                          onClick={() => this.setState({ open: true })}
                          className="product-carousel-close close icon"
                          title="Удалить картинку"
                          aria-hidden="true"
                        ></i>
                      ) : (
                        <></>
                      )}
                      <img src={el} className="product-carousel-image" />
                      <Confirm
                        open={this.state.open}
                        onCancel={() => this.setState({ open: false })}
                        onConfirm={() => {
                          this.deleteImage(el, i)
                          this.setState({ open: false })
                        }}
                        content="Вы уверенны??"
                      />
                    </div>
                  )
                })}
              </Carousel>
            ) : (
              <div
                style={{
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <img src={this.getImage("0.jpg")} style={{ height: "100%" }} />
              </div>
            )}
          </Card>
          <Card
            className="product-name-barcode-container"
            style={{ boxShadow: "0px 0px 0px #FFFFFF" }}
          >
            <div className="product-name-container">
              {settings ? (
                <Input
                  defaultValue={this.state.name}
                  onChange={(e, d) => {
                    this.setState({ name: d.value })
                  }}
                  type="text"
                  style={{ fontSize: 20 }}
                />
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <h2 style={{ marginRight: 10 }}>{this.state.name + " "}</h2>
                </div>
              )}
            </div>
            <div className="product-barcode-container">
              <BarCode
                className={"barcode"}
                value={this.state.barcode}
                ref={(el) => (this.componentRef = el)}
              />
              {settings ? (
                <></>
              ) : (
                <ReactToPrint
                  trigger={() => (
                    <Button
                      circular
                      icon="print"
                      color="green"
                      style={{ margin: 0 }}
                    />
                  )}
                  content={() => this.componentRef}
                />
              )}
            </div>
          </Card>
        </Card.Group>
        <p></p>
        <Table celled>
          <Table.Body>
            <Table.Row>
              <Table.Cell>{t("purchasePrice1")}: </Table.Cell>
              <Table.Cell>
                {settings ? (
                  <Input
                    type="number"
                    defaultValue={this.state.purchasePrice}
                    onChange={(e, d) => {
                      this.setState({ purchasePrice: d.value })
                    }}
                  />
                ) : (
                  <p>{this.state.purchasePrice}</p>
                )}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>{t("salePrice1")}: </Table.Cell>
              <Table.Cell>
                {settings ? (
                  <Input
                    type="number"
                    defaultValue={this.state.salePrice}
                    onChange={(e, d) => {
                      this.setState({ salePrice: d.value })
                    }}
                  />
                ) : (
                  <p>{this.state.salePrice}</p>
                )}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>{t("remainderOnStorage")}: </Table.Cell>
              <Table.Cell>
                {this.state.remainder} {this.state.shortName}
              </Table.Cell>
            </Table.Row>
            {this.state.attributes.map((el) => {
              return (
                <Table.Row>
                  <Table.Cell>{el["name"]}:</Table.Cell>
                  <Table.Cell>
                    {Array.isArray(el["value"])
                      ? el["value"].map((el) => {
                          return (
                            <>
                              <span>{el + " "}</span>
                            </>
                          )
                        })
                      : el["value"]}
                  </Table.Cell>
                </Table.Row>
              )
            })}
          </Table.Body>
        </Table>
      </div>
    )
  }
}

export default ProductPage
